import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import { useIntersection } from 'react-use';
import BVReviews from 'components/consumer/PDP/BazaarVoice/BVReviews';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';
const PDPCustomerPhotos = () => {
  const $ = _c(6);
  const variantSku = usePdpFullVariantSku();
  const containerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      rootMargin: "600px 0px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const intersection = useIntersection(containerRef, t0);
  const hasApproachedViewport = intersection?.isIntersecting;
  let t1;
  if ($[1] !== hasApproachedViewport || $[2] !== variantSku) {
    t1 = hasApproachedViewport && <BVReviews key={variantSku} productId={variantSku} />;
    $[1] = hasApproachedViewport;
    $[2] = variantSku;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div ref={containerRef} className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 min-h-[400px]" id="PDPCustomerPhotos">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default PDPCustomerPhotos;